import InvestorTools from '@/views/InvestorTools/InvestorTools.vue'

export default InvestorTools
